
import { Component, Prop, Vue } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';

@Component<BlockInfo>({ })
export default class BlockInfo extends Vue {
  @Prop()
  private value!: any;

  @Prop()
  private isEditing!: boolean;

  private handleInput(input: string): void {
    const value: any = cloneDeep(this.value);
    value.value = input;
    this.$emit('input', value);
  }
}
